<template>
<div class="emailfindpasswordPage" id="">  
  <XR-head titleText="邮箱找回密码" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="邮箱" icon=":fa fa-envelope-o" labelFloat fullWidth v-model="findInfo.email" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="70" tablet="75" desktop="33">
      <mu-text-field label="验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-key" labelFloat fullWidth v-model="findInfo.code" />
    </mu-col>
    <mu-col width="30" tablet="25" desktop="33">      
      <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="下一步" class="demo-raised-button" primary fullWidth @click="submit()" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div2">
      <mu-sub-header>温馨提醒</mu-sub-header>
      <mu-content-block class="notice">请填写您绑定的邮箱，若邮箱丢失或忘记邮箱可联系客服为您解决！<br />客服电话：<abbr>{{siteInfo.Phone}}</abbr> QQ:<abbr>{{siteInfo.QQ}}</abbr>
      </mu-content-block>
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>

export default {
  data () {
    return {
      findInfo: {
        email :'',
        code : ''
      },
      smsBtnText:'验证码',
      siteInfo:{}
    }
  },
  mounted(){    
    this.getSiteInfo()
  },
  methods: {
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    submit: function () {
      const ths = this;
      this.$post('/Shop/UserServer/FindPasswordGetEmailResult', this.findInfo)
        .then(function (res) {
          if(res.IsSuccess){
            ths.$router.push("/EmailFindPasswordReset?email="+ths.findInfo.email+"&code="+ths.findInfo.code)
          }else{
            ths.$refs.XRtoast.failed(res.Msg, true)            
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    getSmsCode: function(){
      const ths = this;
      ths.$refs.XRtoast.load("正在处理...")
      this.$post('/Shop/UserServer/FindPasswordCheckEmail', this.findInfo)
        .then(function (res) {
          ths.$refs.XRtoast.hide()
          if(res.IsSuccess){
            ths.smsBtnText = res.Data * 60;
            var interval = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
              }else{
                ths.smsBtnText = '验证码'
                clearInterval(interval)
              }
            }, 1000)  
          }else{
            ths.$refs.XRtoast.failed(res.Msg, true)            
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    }
  }
}

</script>
<style>
body .emailfindpasswordPage {
  background: white;
}
.emailfindpasswordPage .login-form {
  padding: 10px 20px 20px 10px;
}
.emailfindpasswordPage .login-div {
  padding: 40px 0px 0 20px;
}
.emailfindpasswordPage .demo-raised-button {
  height: 50px;
}
.emailfindpasswordPage .div2 {
  padding: 20px 0 0 0;
}
.emailfindpasswordPage .demo-flat-button.right {
  float: right;
}
.emailfindpasswordPage .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.emailfindpasswordPage .findpassword .notice{
  font-size: 12px;
}
.emailfindpasswordPage .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/emailFindPassword.vue